import { linkGroupConfig, linkConfig } from '../../../constants';
import { convertLinkGroup } from '../../../utils';
import { isNil } from 'ramda';
export var generateMenuItems = function generateMenuItems(f) {
  return [convertLinkGroup(f, {
    title: 'What we offer',
    links: [linkConfig.packages.family, linkConfig.packages.domestic, linkConfig.packages.group]
  }), convertLinkGroup(f, linkGroupConfig.whoweare), convertLinkGroup(f, {
    title: 'Help',
    links: [linkConfig.claims, linkConfig.contact, linkConfig.resources]
  })];
};
export var generateLoginItem = function generateLoginItem(f) {
  return !isNil(f) ? convertLinkGroup(f, {
    title: '',
    links: [linkConfig.login]
  }) : {
    title: '',
    links: []
  };
};